(() => {
  const COUNTRY = (window.__SHOPIFY_VISITOR_COUNTRY__ || "").toUpperCase();
  const IS_US = COUNTRY === "US";
  const TARGET = ".upcart-rewards";

  function applyTo(el) {
    if (!el) return;

    // If US, undo the default CSS hide. If not US, keep hidden.
    if (IS_US) {
      el.style.setProperty("display", "", "important");
    } else {
      el.style.setProperty("display", "none", "important");
    }
  }

  function scanAndApply(root) {
    if (!root || root.nodeType !== 1) return;

    // If the root itself is the target
    if (root.matches && root.matches(TARGET)) applyTo(root);

    // Or if it contains targets
    if (root.querySelectorAll) {
      root.querySelectorAll(TARGET).forEach(applyTo);
    }

    // If UpCart (or another wrapper) uses OPEN shadow DOM, handle it too
    if (root.shadowRoot) {
      scanAndApply(root.shadowRoot.host);
      // Search inside shadow root
      root.shadowRoot.querySelectorAll(TARGET).forEach(applyTo);
    }
  }

  // Apply to anything already on the page
  scanAndApply(document.documentElement);

  // Watch for UpCart injecting/re-rendering
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const n of m.addedNodes) {
        if (n.nodeType === 1) scanAndApply(n);
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
